export const bet365AffiliateCodes = {
  nextBatsmanOut : '365_728176',
  endOfOver : '365_728177',
  scoreboard : '365_728175',
  editions : '365_728182',
  scoreboardEdition: '365_728181',
  details: '365_728983',
  detailsEdition: '365_728989',
  findMore: '365_728981',
  findMoreEdition: '365_728988'
}



// WEBPACK FOOTER //
// ../app/constants/bet365AffiliateCodes.js